// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".close_toaster_button-module__close--1Z04d{-webkit-align-self:flex-start;-ms-flex-item-align:start;align-self:flex-start;padding:0;cursor:pointer}.close_toaster_button-module__white--Ao4W7{color:#fff}.close_toaster_button-module__black--2v6cM{color:#303030}.close_toaster_button-module__icon--2cZ7j{font-size:18px}\n", ""]);
// Exports
exports.locals = {
	"close": "close_toaster_button-module__close--1Z04d",
	"white": "close_toaster_button-module__white--Ao4W7",
	"black": "close_toaster_button-module__black--2v6cM",
	"icon": "close_toaster_button-module__icon--2cZ7j"
};
module.exports = exports;
